import { Link } from 'react-router-dom';
import BookCallCTA from '../components/BookCallCTA';
import { useSeo } from '../hooks/useSeo';

export default function CanadianRealEstatePage() {
  useSeo({
    title: 'AI Calling for Canadian Real Estate Agents | Point Break Systems',
    description: 'AI calling solutions specifically designed for Canadian real estate agents. English and French calling, CRM integrations, and follow-up workflows built on your accounts. Serving teams across Canada.',
    path: '/canadian-real-estate',
    schemas: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "AI Calling for Canadian Real Estate Agents",
        "description": "Custom AI calling for Canadian real estate professionals with bilingual support and CRM integration",
        "url": "https://pointbreak.systems/canadian-real-estate",
        "inLanguage": "en-CA",
        "about": {
          "@type": "Service", "@id": "https://pointbreak.systems/canadian-real-estate#service",
          "name": "AI Voice Calling for Canadian Real Estate",
          "provider": {
            "@type": "Organization", "@id": "https://pointbreak.systems/#organization",
            "name": "Point Break Systems"
          },
          "areaServed": {
            "@type": "Country",
            "name": "Canada"
          },
          "availableLanguage": ["English", "French"]
        }
      },
    ],
  });

  return (
    <div className="bg-white">
      <section className="max-w-5xl mx-auto px-5 sm:px-6 pt-8 pb-8 sm:pt-14 sm:pb-10">
        <p className="text-sm font-semibold text-gray-500 mb-3">Built in Canada</p>
        <h1 className="text-3xl sm:text-5xl font-bold text-gray-900 leading-tight max-w-3xl mb-5">AI calling for Canadian real estate teams.</h1>
        <p className="quick-answer text-lg leading-relaxed text-gray-600 max-w-2xl mb-6">Follow up with leads in English or French, qualify interest, and book appointments in the tools you already use.</p>
        <BookCallCTA />
      </section>
      <section className="bg-[#fdfcf9] py-8 sm:py-12"><div className="max-w-5xl mx-auto px-5 sm:px-6"><h2 className="text-2xl font-bold text-gray-900 mb-5">Built around your market</h2><div className="grid sm:grid-cols-2 gap-x-12">
        {[
          ['English and French', 'Scripts and voices configured for your language, lead types, and qualification criteria.'],
          ['Your existing CRM', 'Call notes, outcomes, and appointments flow back to your team. We confirm compatibility before the build.'],
          ['Your calling rules', 'Configure consent records, opt-out handling, and calling windows for your outreach.'],
          ['Your own accounts', 'You control the infrastructure and call data. We handle setup and ongoing refinement.']
        ].map(([title, body]) => <div key={title} className="canadian-benefit border-t border-gray-200 py-4"><h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3><p className="text-base leading-relaxed text-gray-600">{body}</p></div>)}
      </div></div></section>
      <section id="how-it-works" className="max-w-5xl mx-auto px-5 sm:px-6 py-8 sm:py-12 grid md:grid-cols-2 gap-8 md:gap-12">
        <div><h2 className="text-2xl font-bold text-gray-900 mb-3">Connect. Call. Book.</h2><p className="text-base leading-relaxed text-gray-600">We connect your lead source, train your caller, and test the workflow with you. Most builds take 2 to 3 weeks.</p></div>
        <div><h2 className="text-2xl font-bold text-gray-900 mb-3">From coast to coast</h2><p className="text-base leading-relaxed text-gray-600">Working with teams across Canada, including Toronto, Vancouver, Montreal, Calgary, Edmonton, Ottawa, Winnipeg, and Atlantic Canada.</p></div>
      </section>
      <section className="border-t border-gray-200 py-8 sm:py-10"><div className="max-w-5xl mx-auto px-5 sm:px-6 flex flex-col sm:flex-row sm:items-center justify-between gap-5"><div><h2 className="text-2xl font-bold text-gray-900">Let's look at your workflow.</h2><p className="text-base text-gray-600 mt-2">Bring your CRM, lead sources, and follow-up goals.</p><Link to="/faq" className="inline-block text-sm text-gray-700 underline underline-offset-4 mt-3">Questions about setup or calling requirements?</Link></div><BookCallCTA className="self-start shrink-0" /></div></section>
    </div>
  );
}
